// react_frontend/src/Constant.js
const Constant = {
    // BASE_URL : 'http://127.0.0.1:8000/api/v1'
     BASE_URL: 'https://api-pos.softsolutionmedia.com/api/v1'
}

export default Constant;